import axios from '@/config/httpConfig'
// 获取菜单列表
export function getSetupList(v) {
    return axios.post('setup/getSetupList', v)
}
